import {observable, action, computed} from 'mobx';
import _ from 'lodash';
import { SUPPORT_RUNNING_TICKER_PAGES } from '../common/Foundation';
import cookie from 'react-cookies';
import Utils from '../common/Utils';

export default class LayoutTemplateStore {
  @observable templateData = {}
  @observable isWait = true;
  @observable fixed = {
    header: '',
    body: ''
  }

  @observable sidebarProps = {
    docked: false,
    open: false,
    pullRight: false,
    alwaysShowLeft: false,
    alwaysShowRight: false
  };

  @observable currentPageContainer = 'sportPageContainer';
  @observable currentViewContainer = 'asiaView';
  @observable isUseMasterLayout = true;
  @observable reloadInternal = false;
  @observable isValidPage = true;
  @observable isDisplayRunningTicker = true;
  @observable isAllowCheckValidPage = false;
  @observable isShowFooter = true;

  @action updateShowFooter (show) {
    this.isShowFooter = show;
  }

  @action updateIsAllowCheckValidPage ( allowCheckValidPage) {
    this.isAllowCheckValidPage = allowCheckValidPage;
  }

  @action updateIsWait() {
    if (this.isWait) {
      this.isWait = false;
    }
  }
  @action updateReloadInternal(isReloadInternal) {
    this.reloadInternal = isReloadInternal;
  }

  @action updateIsValidPage(isValidPage) {
    this.isValidPage = isValidPage;
  }

  @action updateDisplayRunningTicker(isDisplayRunningTicker) {
    this.isDisplayRunningTicker = isDisplayRunningTicker;
  }

  @action updateSideBar(isRight) {
    if (window.innerWidth >= 1025) {
      let isPullRight;
      if(isRight) {
        isPullRight = true;
        if(this.sidebarProps.alwaysShowLeft) {
          this.updateAlwaysShowSideBar(false, true);
        } else if(this.sidebarProps.alwaysShowRight){
            this.updateAlwaysShowSideBar(false, false);
        } else {
          this.updateAlwaysShowSideBar(false, true);
        }
      } else {
        isPullRight = false;
        if(this.sidebarProps.alwaysShowRight) {
          this.updateAlwaysShowSideBar(true, false);
        } else if(this.sidebarProps.alwaysShowLeft) {
            this.updateAlwaysShowSideBar(false, false);
        } else {
          this.updateAlwaysShowSideBar(true, false);
        }
      }
      if(this.sidebarProps.pullRight !== isPullRight) {
        this.sidebarProps.pullRight = isPullRight;
      }  
    } else {
      let isDocked = !this.sidebarProps.docked,
        isPullRight;
      if (isRight) {
        isPullRight = true;
        if (this.sidebarProps.docked && !this.sidebarProps.pullRight) {
          isDocked = true;
        }
      } else {
        isPullRight = false;
        if (this.sidebarProps.docked && this.sidebarProps.pullRight) {
          isDocked = true;
        }
      }
      if(this.sidebarProps.docked !== isDocked)  this.sidebarProps.docked = isDocked;
      if(this.sidebarProps.pullRight !== isPullRight)  this.sidebarProps.pullRight = isPullRight;
    }
  }

  @action closeSideBar() {
    if(this.sidebarProps.docked) this.sidebarProps.docked = false;    
    if(this.sidebarProps.open) this.sidebarProps.open = false;
  }

  @action asiaCloseSideBar() {
    this.sidebarProps.alwaysShowLeft = false;
    this.sidebarProps.alwaysShowRight = false;
    this.closeSideBar();
  }

  @action updateAlwaysShowSideBar(left, right) {
    if (this.sidebarProps.alwaysShowLeft != left) {
      this.sidebarProps.alwaysShowLeft = left;
      if (this.sidebarProps.docked || this.sidebarProps.open) {
        this.closeSideBar();
      }
    }
    if (this.sidebarProps.alwaysShowRight != right) {
      this.sidebarProps.alwaysShowRight = right;
      if (this.sidebarProps.docked || this.sidebarProps.open) {
        this.closeSideBar();
      }
    }

  }

  @action updateTemplateData(data) {
    Object.keys(data).map(key => {
      this.templateData[key] = data[key];
    })

  }

  @action updateCurrentPageContainer(pageNameContainer) {
    if(this.currentPageContainer !== pageNameContainer){
        this.currentPageContainer = pageNameContainer;
    }
  

  }

  @action updateCurrentViewContainer(viewNameContainer) {
    if(this.currentViewContainer !== viewNameContainer){
      this.currentViewContainer = viewNameContainer;
    }

  }

  @action updateIsUseMasterLayout(isUseMasterLayout) {
    if(this.isUseMasterLayout !== isUseMasterLayout){
         this.isUseMasterLayout = isUseMasterLayout;
    }   
  }

  @computed get isSeamless() {
    return _.get(this.templateData, 'attributes.isSeamless', false);

  }
  @computed get displayRunningTicker() {
    const supportedPages = SUPPORT_RUNNING_TICKER_PAGES[this.currentViewContainer];
    const isSupportedPage = supportedPages ? supportedPages.includes(this.currentPageContainer) : true;
    return Utils.isEnableAnnouncement() && isSupportedPage && this.isDisplayRunningTicker;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/LayoutTemplateStore.js